import * as React from "react"
import { Button, ButtonProps } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

interface ConfirmationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  text: string
  onConfirm: () => void
  onCancel?: () => void
  skin?: ButtonProps["skin"]
}

export function ConfirmationDialog(props: ConfirmationDialogProps) {
  const { open, onOpenChange, title, text, skin, onConfirm, onCancel } = props
  const handleCancel = () => {
    onOpenChange(false)
    onCancel?.()
  }
  const handleConfirm = () => {
    onConfirm()
    onOpenChange(false)
  }
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{text}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type={'button'} variant="outline" onClick={handleCancel}>
            Cancel
          </Button>
          <Button type={'button'} skin={skin} onClick={handleConfirm}>
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
